import { render } from "./SalesFunnel.vue?vue&type=template&id=36323b4d&scoped=true"
import script from "./SalesFunnel.vue?vue&type=script&lang=js"
export * from "./SalesFunnel.vue?vue&type=script&lang=js"

import "./SalesFunnel.vue?vue&type=style&index=0&id=36323b4d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36323b4d"]])

export default __exports__